import { Box, Typography } from '@mui/material';
import type { ContentSectionProps } from './types';

/**
 * A named block of a content page: a heading, an optional line under it, and
 * whatever it is about.
 *
 * **It is the same component for prose and for a grid of cards**, which is what
 * keeps the heading rhythm identical down a page whose sections hold very
 * different things. A section that laid its own heading out would be four
 * pixels off within a week.
 *
 * The caption is 14px grey under a 20px Poppins heading, so it reads as a
 * standfirst rather than as the section's first line of content.
 */
export const ContentSection = ({ heading, caption, level = 2, children }: ContentSectionProps) => (
  <Box component="section">
    <Typography variant="h3" component={`h${String(level)}` as 'h2' | 'h3'}>
      {heading}
    </Typography>

    {caption !== undefined && (
      <Typography variant="body2" sx={{ color: 'text.secondary', marginTop: 1 }}>
        {caption}
      </Typography>
    )}

    <Box sx={{ marginTop: 4 }}>{children}</Box>
  </Box>
);
